export default __webpack_public_path__ + "static/media/Proxima-Nova-Reg-It.01cb8264.ttf";